var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Bar", {
    attrs: {
      "chart-id": _vm.chart_id,
      "chart-data": _vm.chartData,
      "chart-options": _vm.chart_options,
      width: _vm.width_,
      height: _vm.height_,
      plugins: _vm.plugins,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }